import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const FAQSchema = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';

  useEffect(() => {
    const faqs = [
      {
        question: t('faq1Question'),
        answer: t('faq1Answer'),
      },
      {
        question: t('faq2Question'),
        answer: t('faq2Answer'),
      },
      {
        question: t('faq3Question'),
        answer: t('faq3Answer'),
      },
      {
        question: t('faq4Question'),
        answer: t('faq4Answer'),
      },
      {
        question: t('faq5Question'),
        answer: t('faq5Answer'),
      },
      {
        question: t('faq6Question'),
        answer: t('faq6Answer'),
      },
      {
        question: t('faq7Question'),
        answer: t('faq7Answer'),
      },
      {
        question: t('faq8Question'),
        answer: t('faq8Answer'),
      },
    ];

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    // Remove existing FAQ schema if any
    const existingSchema = document.getElementById('faq-schema');
    if (existingSchema) {
      existingSchema.remove();
    }

    // Add FAQ schema
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'faq-schema';
    script.text = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      const schema = document.getElementById('faq-schema');
      if (schema) {
        schema.remove();
      }
    };
  }, [currentLang, t]);

  return null;
};

export default FAQSchema;
